import React from 'react';
import { PLATFORMS, ALL_PLATFORMS } from '../../constants/platforms';
import { PlatformIconComponent } from '../../components/icons/PlatformIcons';
import { SAVED_TAB } from '../../App';
import styles from './PlatformFilter.module.css';

const DEAL_TAB_ORDER = [ALL_PLATFORMS, 'epic', 'steam', 'gog', 'itchio'];

function AllIcon({ size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M4 6h16v2H4zm2 5h12v2H6zm3 5h6v2H9z" />
    </svg>
  );
}

function SavedIcon({ size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z" />
    </svg>
  );
}

function PlatformFilter({ activePlatform, onPlatformChange, dealCounts }) {
  return (
    <nav className={styles.nav} aria-label="Platform filter">
      <div className={styles.strip}>
        {DEAL_TAB_ORDER.map(key => {
          const isAll    = key === ALL_PLATFORMS;
          const info     = isAll ? null : PLATFORMS[key];
          const label    = isAll ? 'All' : info.label;
          const count    = dealCounts?.[key] ?? 0;
          const isActive = activePlatform === key;

          if (!isAll && count === 0) return null;

          return (
            <button
              key={key}
              className={`${styles.tab} ${isActive ? styles.active : ''}`}
              onClick={() => onPlatformChange(key)}
              aria-pressed={isActive}
            >
              <span className={styles.tabIcon}>
                {isAll
                  ? <AllIcon size={14} />
                  : <PlatformIconComponent platform={key} size={14} />}
              </span>
              <span className={styles.tabLabel}>{label}</span>
              {count > 0 && (
                <span className={`${styles.count} ${isActive ? styles.countActive : ''}`}>
                  {count}
                </span>
              )}
            </button>
          );
        })}

        {/* Saved tab — always shown, pushed to right */}
        {(() => {
          const savedCount = dealCounts?.[SAVED_TAB] ?? 0;
          const isActive   = activePlatform === SAVED_TAB;
          return (
            <button
              key={SAVED_TAB}
              className={`${styles.tab} ${styles.savedTab} ${isActive ? styles.savedActive : ''}`}
              onClick={() => onPlatformChange(SAVED_TAB)}
              aria-pressed={isActive}
              title="Your saved games"
            >
              <span className={styles.tabIcon}><SavedIcon size={14} /></span>
              <span className={styles.tabLabel}>Saved</span>
              {savedCount > 0 && (
                <span className={`${styles.count} ${isActive ? styles.savedCountActive : ''}`}>
                  {savedCount}
                </span>
              )}
            </button>
          );
        })()}
      </div>
    </nav>
  );
}

export { PlatformFilter };
export default PlatformFilter;
